// Default content for all section types
export const getSectionDefaults = (type) => {
  const defaults = {
    hero: {
      heading: 'Welcome to Your Website',
      subheading: 'Create something amazing',
      buttonText: 'Get Started',
      buttonLink: '#contact',
      backgroundImage: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=1920',
      textColor: '#ffffff',
      overlayOpacity: 0.4
    },
    about: {
      heading: 'About Us',
      text: 'Tell your story here. Share what makes your business unique.',
      image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800',
      backgroundColor: '#ffffff',
      textColor: '#1f2937'
    },
    services: {
      heading: 'Our Services',
      items: [
        { icon: '✨', title: 'Service 1', description: 'Description here' },
        { icon: '🚀', title: 'Service 2', description: 'Description here' },
        { icon: '💎', title: 'Service 3', description: 'Description here' }
      ],
      backgroundColor: '#f9fafb',
      textColor: '#1f2937'
    },
    contact: {
      heading: 'Get In Touch',
      email: 'contact@example.com',
      phone: '+1 (555) 123-4567',
      address: '123 Business St, City',
      backgroundColor: '#1f2937',
      textColor: '#ffffff'
    },
    gallery: {
      heading: 'Our Gallery',
      images: [
        { url: 'https://images.pexels.com/photos/1181391/pexels-photo-1181391.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Gallery 1' },
        { url: 'https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Gallery 2' },
        { url: 'https://images.pexels.com/photos/1181216/pexels-photo-1181216.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Gallery 3' },
        { url: 'https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Gallery 4' },
        { url: 'https://images.pexels.com/photos/1181605/pexels-photo-1181605.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Gallery 5' },
        { url: 'https://images.pexels.com/photos/1181269/pexels-photo-1181269.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Gallery 6' }
      ],
      columns: 3,
      backgroundColor: '#ffffff'
    },
    testimonials: {
      heading: 'What Our Clients Say',
      testimonials: [
        {
          text: 'Amazing service! Highly recommend to anyone looking for quality work.',
          author: 'John Doe',
          role: 'CEO, Company Inc',
          rating: 5,
          image: ''
        },
        {
          text: 'Professional, reliable, and delivered beyond expectations.',
          author: 'Jane Smith',
          role: 'Marketing Director',
          rating: 5,
          image: ''
        }
      ],
      backgroundColor: '#f9fafb',
      textColor: '#1f2937'
    },
    features: {
      heading: 'Why Choose Us',
      subheading: 'Discover what makes us different',
      features: [
        { icon: '⚡', title: 'Fast Performance', description: 'Lightning-fast load times' },
        { icon: '🔒', title: 'Secure', description: 'Bank-level security' },
        { icon: '📱', title: 'Mobile Ready', description: 'Works on all devices' },
        { icon: '🎨', title: 'Beautiful Design', description: 'Stunning visuals' },
        { icon: '⚙️', title: 'Easy to Use', description: 'Simple and intuitive' },
        { icon: '🚀', title: 'Always Updated', description: 'Regular improvements' }
      ],
      backgroundColor: '#ffffff',
      textColor: '#1f2937'
    },
    pricing: {
      heading: 'Choose Your Plan',
      subheading: 'Flexible pricing for every need',
      plans: [
        {
          name: 'Basic',
          price: '29',
          period: 'per month',
          features: ['Feature 1', 'Feature 2', 'Feature 3'],
          buttonText: 'Get Started',
          highlighted: false
        },
        {
          name: 'Pro',
          price: '79',
          period: 'per month',
          features: ['All Basic features', 'Feature 4', 'Feature 5', 'Priority Support'],
          buttonText: 'Get Started',
          highlighted: true
        },
        {
          name: 'Enterprise',
          price: '199',
          period: 'per month',
          features: ['All Pro features', 'Custom integration', 'Dedicated manager'],
          buttonText: 'Contact Us',
          highlighted: false
        }
      ],
      backgroundColor: '#f9fafb',
      textColor: '#1f2937'
    },
    team: {
      heading: 'Meet Our Team',
      subheading: 'The people behind our success',
      members: [
        { name: 'Alice Johnson', role: 'CEO & Founder', bio: '', image: '', social: {} },
        { name: 'Bob Smith', role: 'CTO', bio: '', image: '', social: {} },
        { name: 'Carol Williams', role: 'Design Lead', bio: '', image: '', social: {} },
        { name: 'David Brown', role: 'Marketing Director', bio: '', image: '', social: {} }
      ],
      backgroundColor: '#ffffff',
      textColor: '#1f2937'
    },
    faq: {
      heading: 'Frequently Asked Questions',
      subheading: 'Find answers to common questions',
      faqs: [
        { question: 'What is your refund policy?', answer: 'We offer a 30-day money-back guarantee.' },
        { question: 'How do I get started?', answer: 'Simply sign up and follow our onboarding guide.' },
        { question: 'Do you offer support?', answer: 'Yes, we provide 24/7 customer support.' },
        { question: 'Can I upgrade my plan?', answer: 'Yes, you can upgrade anytime from your dashboard.' }
      ],
      backgroundColor: '#ffffff',
      textColor: '#1f2937'
    },
    newsletter: {
      heading: 'Subscribe to Our Newsletter',
      subheading: 'Get the latest updates delivered to your inbox',
      buttonText: 'Subscribe',
      placeholder: 'Enter your email',
      backgroundColor: '#1e40af',
      textColor: '#ffffff'
    },
    video: {
      heading: 'Watch Our Story',
      subheading: 'See what we\'re all about',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      thumbnail: '',
      backgroundColor: '#000000',
      textColor: '#ffffff'
    },
    stats: {
      heading: 'Our Achievements',
      subheading: 'Numbers that speak for themselves',
      stats: [
        { number: '10K+', label: 'Happy Customers' },
        { number: '50+', label: 'Team Members' },
        { number: '99%', label: 'Satisfaction Rate' },
        { number: '24/7', label: 'Support Available' }
      ],
      backgroundColor: '#1f2937',
      textColor: '#ffffff'
    }
  };
  
  return defaults[type] || {};
};
